/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-CMS Content Page API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanValueRestDto } from '../models';
import { ContentPageCreateRestDto } from '../models';
import { ContentPageRestDto } from '../models';
import { ElementTargetPositionRestDto } from '../models';
import { FullContentPageRestDto } from '../models';
import { IdResponseRestDto } from '../models';
import { IdRestDto } from '../models';
import { PageTypeRestDto } from '../models';
import { PagedContentPageOverviewRestDto } from '../models';
import { StatusValueRestDto } from '../models';
import { WysiwygContentPageRestDto } from '../models';
/**
 * ContentPageEndpointsApi - axios parameter creator
 * @export
 */
export const ContentPageEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CMS.CP.06 Copy content page.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [to_customer_code] When provided, the page will be copied to the customer that corresponds to the value of this param. NOTE that this parameter is ONLY allowed by a Digital Pharma user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyContentPage: async (page_id: string, x_dp_customer_code?: string|null, to_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling copyContentPage.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/copy`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (!!to_customer_code || typeof(to_customer_code) === "boolean") {
                localVarQueryParameter['to_customer_code'] = to_customer_code;
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Copies the page of type page_type_code of the current customer (identified by x-dp-customer-code) to the customer identified by to_customer_code. Named page types are page types of which a customer can have at most one page: HOME_PAGE_CONTENT, WS_INFO_PAGE_ORDER, WS_INFO_PAGE_PAY, WS_INFO_PAGE_POST_SALE_ASSISTANCE, WS_INFO_PAGE_RETURN_POLICY_AND_COMPLAINTS, WS_INFO_PAGE_SHIPPING_AND_DELIVERY. The home page (HOME_PAGE_CONTENT) is copied with this operation as well. The page, its rows and its content blocks are copied as with REST.API.CMS.CP.06, except for the name, slug, sort_weight and status: the copy gets the values a newly created named page of the target customer gets (REST.API.CMS.CP.20): for HOME_PAGE_CONTENT name 'Home' and slug 'home'; for the other named page types the description of the page type in the content language of the target customer as name and the lowercase page type code as slug; sort_weight 1; status PUBLISHED. No '_copy' suffix is added to name or slug. Authorization: a Digital Pharma user may copy to any customer; any other user may copy only to a customer in the same i18n group as the current customer (another language of the same pharmacy), otherwise the request is refused with 403. When the target customer already has a page of this type, the request is refused with a confirmable 400 (see the 400 response); when the caller confirms that refusal, the existing page of the target customer is deleted (under the rules of REST.API.CMS.CP.05, except that named page types, which are not deletable on their own, may be deleted here because the page is replaced by the copy) and replaced by the copy in one transaction. Without that confirmation nothing is changed. A page with a custom design (the source page, or the existing page of the target customer) cannot be copied or overwritten by a user who is not a Digital Pharma user (final 400); a Digital Pharma user gets a confirmable 400 for it instead. All applicable confirmable refusals are returned together in one 400 (see the 400 response).
         * @summary REST.API.CMS.CP.21 Copy named page to another customer.
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer. This is the customer whose page of type page_type_code is copied (source).
         * @param {string} page_type_code The type of the named page of the current customer that is copied. Must be a named page type: HOME_PAGE_CONTENT, WS_INFO_PAGE_ORDER, WS_INFO_PAGE_PAY, WS_INFO_PAGE_POST_SALE_ASSISTANCE, WS_INFO_PAGE_RETURN_POLICY_AND_COMPLAINTS, WS_INFO_PAGE_SHIPPING_AND_DELIVERY. Any other value is refused with 400.
         * @param {string} to_customer_code The code of the customer the page is copied to. Must differ from the current customer (x-dp-customer-code), otherwise 400. A Digital Pharma user may copy to any existing customer; a non existing customer is refused with 400. Any other user may copy only to a customer in the same i18n group as the current customer (another language of the same pharmacy); any other value, including a non existing customer, is refused with 403.
         * @param {string} [x_dp_language] Indicates in which language the content and possible application errors are expected. (Fallback to default language for customer if not provided.) The request language does not affect the name of the copied page: that name uses the content language of the target customer.
         * @param {string} [x_dp_ignore_app_error_codes] Comma separated list of error codes the caller confirmed and that should therefore be disregarded when executing the request. The codes this operation accepts as confirmable are 10215 (FAULT_CBCP_COPY_SOURCE_HAS_CUSTOM_DESIGN) and 10216 (FAULT_CBCP_COPY_TARGET_HAS_CUSTOM_DESIGN), for a Digital Pharma user only, and 10214 (FAULT_CBCP_TARGET_NAMED_PAGE_ALREADY_EXISTS), see the 400 response; any other code named here, and 10215 or 10216 for a user who is not a Digital Pharma user, has no effect and its refusal still applies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyNamedPage: async (x_dp_customer_code: string, page_type_code: string, to_customer_code: string, x_dp_language?: string|null, x_dp_ignore_app_error_codes?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling copyNamedPage.');
            }
            // verify required parameter 'page_type_code' is not null or undefined
            if (page_type_code === null || page_type_code === undefined) {
                throw new RequiredError('page_type_code','Required parameter page_type_code was null or undefined when calling copyNamedPage.');
            }
            // verify required parameter 'to_customer_code' is not null or undefined
            if (to_customer_code === null || to_customer_code === undefined) {
                throw new RequiredError('to_customer_code','Required parameter to_customer_code was null or undefined when calling copyNamedPage.');
            }
            const localVarPath = `/content_page/v1/named_page/{page_type_code}/copy`
                .replace(`{${"page_type_code"}}`, encodeURIComponent(String(page_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (!!to_customer_code || typeof(to_customer_code) === "boolean") {
                localVarQueryParameter['to_customer_code'] = to_customer_code;
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            if (x_dp_ignore_app_error_codes !== undefined && x_dp_ignore_app_error_codes !== null) {
                localVarHeaderParameter['x-dp-ignore-app-error-codes'] = String(x_dp_ignore_app_error_codes);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.02 Create content page.
         * @param {ContentPageCreateRestDto} body 
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContentPage: async (body: ContentPageCreateRestDto, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createContentPage.');
            }
            const localVarPath = `/content_page/v1/content_page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.15 Create home page
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHomePage: async (x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/content_page/v1/home_page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.20 Create named page
         * @param {string} page_type_code The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNamedPage: async (page_type_code: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_type_code' is not null or undefined
            if (page_type_code === null || page_type_code === undefined) {
                throw new RequiredError('page_type_code','Required parameter page_type_code was null or undefined when calling createNamedPage.');
            }
            const localVarPath = `/content_page/v1/named_page/{page_type_code}`
                .replace(`{${"page_type_code"}}`, encodeURIComponent(String(page_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.05 Delete content page.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContentPage: async (page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling deleteContentPage.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.01 Get all content pages for a customer.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [search_name] Zoek de resultaten waarbij de opgegeven parameter voorkomt in de waarde van het name veld. (Er wordt case insensitive gezocht.)
         * @param {string} [filter_type_code] Filter de resultaten tot die overeenkomen met het gespecifieerde type
         * @param {string} [filter_library_code] Filter de resultaten tot die waarbij ze behoren tot de gespecifieerde library
         * @param {boolean} [expect_alt_lang_pages] If provided and true, the pages of alternative languages are included in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findContentPages: async (x_dp_customer_code?: string|null, search_name?: string|null, filter_type_code?: string|null, filter_library_code?: string|null, expect_alt_lang_pages?: boolean|null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/content_page/v1/content_page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (!!search_name || typeof(search_name) === "boolean") {
                localVarQueryParameter['search_name'] = search_name;
            }

            if (!!filter_type_code || typeof(filter_type_code) === "boolean") {
                localVarQueryParameter['filter_type_code'] = filter_type_code;
            }

            if (!!filter_library_code || typeof(filter_library_code) === "boolean") {
                localVarQueryParameter['filter_library_code'] = filter_library_code;
            }

            if (!!expect_alt_lang_pages || typeof(expect_alt_lang_pages) === "boolean") {
                localVarQueryParameter['expect_alt_lang_pages'] = expect_alt_lang_pages;
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.04 Get content page.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentPage: async (page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling getContentPage.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.13 Get content page for wysiwyg modus.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentPageWysiwyg: async (page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling getContentPageWysiwyg.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/wysiwyg`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.14 Get home page for wysiwyg modus.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomePageWysiwyg: async (x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/content_page/v1/home_page/wysiwyg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.19 Get named page for wysiwyg modus.
         * @param {string} page_type_code The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNamedPageWysiwyg: async (page_type_code: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_type_code' is not null or undefined
            if (page_type_code === null || page_type_code === undefined) {
                throw new RequiredError('page_type_code','Required parameter page_type_code was null or undefined when calling getNamedPageWysiwyg.');
            }
            const localVarPath = `/content_page/v1/named_page/{page_type_code}/wysiwyg`
                .replace(`{${"page_type_code"}}`, encodeURIComponent(String(page_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.10 Move content page one position down.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveContentPageDown: async (page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling moveContentPageDown.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/move/down`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.11 Move content page to position between two others.
         * @param {ElementTargetPositionRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveContentPageTo: async (body: ElementTargetPositionRestDto, page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling moveContentPageTo.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling moveContentPageTo.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/move/to`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.08 Move content page to the bottom position.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveContentPageToBottom: async (page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling moveContentPageToBottom.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/move/to_bottom`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.07 Move content page to the top position.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveContentPageToTop: async (page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling moveContentPageToTop.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/move/to_top`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.09 Move content page one position up.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveContentPageUp: async (page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling moveContentPageUp.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/move/up`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.16 Paste a row to this content page.
         * @param {IdRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pasteRowOnContentPage: async (body: IdRestDto, page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling pasteRowOnContentPage.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling pasteRowOnContentPage.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/paste_row`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.03 Update content page.
         * @param {ContentPageRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentPage: async (body: ContentPageRestDto, page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateContentPage.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling updateContentPage.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.12 Update the type of the content page.
         * @param {PageTypeRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentPageType: async (body: PageTypeRestDto, page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateContentPageType.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling updateContentPageType.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/change_type`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.17 Update the field is_published_on_home of the content page.
         * @param {BooleanValueRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIsPublishedOnHome: async (body: BooleanValueRestDto, page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateIsPublishedOnHome.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling updateIsPublishedOnHome.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/is_published_on_home`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.18 Update the field status_code of the content page.
         * @param {StatusValueRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageStatusCode: async (body: StatusValueRestDto, page_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePageStatusCode.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling updatePageStatusCode.');
            }
            const localVarPath = `/content_page/v1/content_page/{page_id}/status`
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentPageEndpointsApi - functional programming interface
 * @export
 */
export const ContentPageEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CMS.CP.06 Copy content page.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [to_customer_code] When provided, the page will be copied to the customer that corresponds to the value of this param. NOTE that this parameter is ONLY allowed by a Digital Pharma user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyContentPage(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, to_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).copyContentPage(page_id, x_dp_customer_code, to_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Copies the page of type page_type_code of the current customer (identified by x-dp-customer-code) to the customer identified by to_customer_code. Named page types are page types of which a customer can have at most one page: HOME_PAGE_CONTENT, WS_INFO_PAGE_ORDER, WS_INFO_PAGE_PAY, WS_INFO_PAGE_POST_SALE_ASSISTANCE, WS_INFO_PAGE_RETURN_POLICY_AND_COMPLAINTS, WS_INFO_PAGE_SHIPPING_AND_DELIVERY. The home page (HOME_PAGE_CONTENT) is copied with this operation as well. The page, its rows and its content blocks are copied as with REST.API.CMS.CP.06, except for the name, slug, sort_weight and status: the copy gets the values a newly created named page of the target customer gets (REST.API.CMS.CP.20): for HOME_PAGE_CONTENT name 'Home' and slug 'home'; for the other named page types the description of the page type in the content language of the target customer as name and the lowercase page type code as slug; sort_weight 1; status PUBLISHED. No '_copy' suffix is added to name or slug. Authorization: a Digital Pharma user may copy to any customer; any other user may copy only to a customer in the same i18n group as the current customer (another language of the same pharmacy), otherwise the request is refused with 403. When the target customer already has a page of this type, the request is refused with a confirmable 400 (see the 400 response); when the caller confirms that refusal, the existing page of the target customer is deleted (under the rules of REST.API.CMS.CP.05, except that named page types, which are not deletable on their own, may be deleted here because the page is replaced by the copy) and replaced by the copy in one transaction. Without that confirmation nothing is changed. A page with a custom design (the source page, or the existing page of the target customer) cannot be copied or overwritten by a user who is not a Digital Pharma user (final 400); a Digital Pharma user gets a confirmable 400 for it instead. All applicable confirmable refusals are returned together in one 400 (see the 400 response).
         * @summary REST.API.CMS.CP.21 Copy named page to another customer.
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer. This is the customer whose page of type page_type_code is copied (source).
         * @param {string} page_type_code The type of the named page of the current customer that is copied. Must be a named page type: HOME_PAGE_CONTENT, WS_INFO_PAGE_ORDER, WS_INFO_PAGE_PAY, WS_INFO_PAGE_POST_SALE_ASSISTANCE, WS_INFO_PAGE_RETURN_POLICY_AND_COMPLAINTS, WS_INFO_PAGE_SHIPPING_AND_DELIVERY. Any other value is refused with 400.
         * @param {string} to_customer_code The code of the customer the page is copied to. Must differ from the current customer (x-dp-customer-code), otherwise 400. A Digital Pharma user may copy to any existing customer; a non existing customer is refused with 400. Any other user may copy only to a customer in the same i18n group as the current customer (another language of the same pharmacy); any other value, including a non existing customer, is refused with 403.
         * @param {string} [x_dp_language] Indicates in which language the content and possible application errors are expected. (Fallback to default language for customer if not provided.) The request language does not affect the name of the copied page: that name uses the content language of the target customer.
         * @param {string} [x_dp_ignore_app_error_codes] Comma separated list of error codes the caller confirmed and that should therefore be disregarded when executing the request. The codes this operation accepts as confirmable are 10215 (FAULT_CBCP_COPY_SOURCE_HAS_CUSTOM_DESIGN) and 10216 (FAULT_CBCP_COPY_TARGET_HAS_CUSTOM_DESIGN), for a Digital Pharma user only, and 10214 (FAULT_CBCP_TARGET_NAMED_PAGE_ALREADY_EXISTS), see the 400 response; any other code named here, and 10215 or 10216 for a user who is not a Digital Pharma user, has no effect and its refusal still applies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyNamedPage(_axios: AxiosInstance, x_dp_customer_code: string, page_type_code: string, to_customer_code: string, x_dp_language?: string|null, x_dp_ignore_app_error_codes?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).copyNamedPage(x_dp_customer_code, page_type_code, to_customer_code, x_dp_language, x_dp_ignore_app_error_codes, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.02 Create content page.
         * @param {ContentPageCreateRestDto} body 
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContentPage(_axios: AxiosInstance, body: ContentPageCreateRestDto, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponseRestDto>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).createContentPage(body, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.15 Create home page
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHomePage(_axios: AxiosInstance, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).createHomePage(x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.20 Create named page
         * @param {string} page_type_code The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNamedPage(_axios: AxiosInstance, page_type_code: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).createNamedPage(page_type_code, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.05 Delete content page.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContentPage(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).deleteContentPage(page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.01 Get all content pages for a customer.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [search_name] Zoek de resultaten waarbij de opgegeven parameter voorkomt in de waarde van het name veld. (Er wordt case insensitive gezocht.)
         * @param {string} [filter_type_code] Filter de resultaten tot die overeenkomen met het gespecifieerde type
         * @param {string} [filter_library_code] Filter de resultaten tot die waarbij ze behoren tot de gespecifieerde library
         * @param {boolean} [expect_alt_lang_pages] If provided and true, the pages of alternative languages are included in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findContentPages(_axios: AxiosInstance, x_dp_customer_code?: string|null, search_name?: string|null, filter_type_code?: string|null, filter_library_code?: string|null, expect_alt_lang_pages?: boolean|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedContentPageOverviewRestDto>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).findContentPages(x_dp_customer_code, search_name, filter_type_code, filter_library_code, expect_alt_lang_pages, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.04 Get content page.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentPage(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullContentPageRestDto>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).getContentPage(page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.13 Get content page for wysiwyg modus.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentPageWysiwyg(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WysiwygContentPageRestDto>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).getContentPageWysiwyg(page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.14 Get home page for wysiwyg modus.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomePageWysiwyg(_axios: AxiosInstance, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WysiwygContentPageRestDto>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).getHomePageWysiwyg(x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.19 Get named page for wysiwyg modus.
         * @param {string} page_type_code The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNamedPageWysiwyg(_axios: AxiosInstance, page_type_code: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WysiwygContentPageRestDto>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).getNamedPageWysiwyg(page_type_code, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.10 Move content page one position down.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveContentPageDown(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).moveContentPageDown(page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.11 Move content page to position between two others.
         * @param {ElementTargetPositionRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveContentPageTo(_axios: AxiosInstance, body: ElementTargetPositionRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).moveContentPageTo(body, page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.08 Move content page to the bottom position.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveContentPageToBottom(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).moveContentPageToBottom(page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.07 Move content page to the top position.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveContentPageToTop(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).moveContentPageToTop(page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.09 Move content page one position up.
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveContentPageUp(_axios: AxiosInstance, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).moveContentPageUp(page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.16 Paste a row to this content page.
         * @param {IdRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pasteRowOnContentPage(_axios: AxiosInstance, body: IdRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).pasteRowOnContentPage(body, page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.03 Update content page.
         * @param {ContentPageRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContentPage(_axios: AxiosInstance, body: ContentPageRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).updateContentPage(body, page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.12 Update the type of the content page.
         * @param {PageTypeRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContentPageType(_axios: AxiosInstance, body: PageTypeRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).updateContentPageType(body, page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.17 Update the field is_published_on_home of the content page.
         * @param {BooleanValueRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIsPublishedOnHome(_axios: AxiosInstance, body: BooleanValueRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).updateIsPublishedOnHome(body, page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.CP.18 Update the field status_code of the content page.
         * @param {StatusValueRestDto} body 
         * @param {string} page_id The unique identifier of this content page.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePageStatusCode(_axios: AxiosInstance, body: StatusValueRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ContentPageEndpointsApiAxiosParamCreator(configuration).updatePageStatusCode(body, page_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContentPageEndpointsApi - object-oriented interface
 * @export
 * @class ContentPageEndpointsApi
 * @extends {BaseAPI}
 */
export class ContentPageEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.CMS.CP.06 Copy content page.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [to_customer_code] When provided, the page will be copied to the customer that corresponds to the value of this param. NOTE that this parameter is ONLY allowed by a Digital Pharma user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public copyContentPage(page_id: string, x_dp_customer_code?: string|null, to_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).copyContentPage(this.axios, page_id, x_dp_customer_code, to_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Copies the page of type page_type_code of the current customer (identified by x-dp-customer-code) to the customer identified by to_customer_code. Named page types are page types of which a customer can have at most one page: HOME_PAGE_CONTENT, WS_INFO_PAGE_ORDER, WS_INFO_PAGE_PAY, WS_INFO_PAGE_POST_SALE_ASSISTANCE, WS_INFO_PAGE_RETURN_POLICY_AND_COMPLAINTS, WS_INFO_PAGE_SHIPPING_AND_DELIVERY. The home page (HOME_PAGE_CONTENT) is copied with this operation as well. The page, its rows and its content blocks are copied as with REST.API.CMS.CP.06, except for the name, slug, sort_weight and status: the copy gets the values a newly created named page of the target customer gets (REST.API.CMS.CP.20): for HOME_PAGE_CONTENT name 'Home' and slug 'home'; for the other named page types the description of the page type in the content language of the target customer as name and the lowercase page type code as slug; sort_weight 1; status PUBLISHED. No '_copy' suffix is added to name or slug. Authorization: a Digital Pharma user may copy to any customer; any other user may copy only to a customer in the same i18n group as the current customer (another language of the same pharmacy), otherwise the request is refused with 403. When the target customer already has a page of this type, the request is refused with a confirmable 400 (see the 400 response); when the caller confirms that refusal, the existing page of the target customer is deleted (under the rules of REST.API.CMS.CP.05, except that named page types, which are not deletable on their own, may be deleted here because the page is replaced by the copy) and replaced by the copy in one transaction. Without that confirmation nothing is changed. A page with a custom design (the source page, or the existing page of the target customer) cannot be copied or overwritten by a user who is not a Digital Pharma user (final 400); a Digital Pharma user gets a confirmable 400 for it instead. All applicable confirmable refusals are returned together in one 400 (see the 400 response).
     * @summary REST.API.CMS.CP.21 Copy named page to another customer.
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer. This is the customer whose page of type page_type_code is copied (source).
     * @param {string} page_type_code The type of the named page of the current customer that is copied. Must be a named page type: HOME_PAGE_CONTENT, WS_INFO_PAGE_ORDER, WS_INFO_PAGE_PAY, WS_INFO_PAGE_POST_SALE_ASSISTANCE, WS_INFO_PAGE_RETURN_POLICY_AND_COMPLAINTS, WS_INFO_PAGE_SHIPPING_AND_DELIVERY. Any other value is refused with 400.
     * @param {string} to_customer_code The code of the customer the page is copied to. Must differ from the current customer (x-dp-customer-code), otherwise 400. A Digital Pharma user may copy to any existing customer; a non existing customer is refused with 400. Any other user may copy only to a customer in the same i18n group as the current customer (another language of the same pharmacy); any other value, including a non existing customer, is refused with 403.
     * @param {string} [x_dp_language] Indicates in which language the content and possible application errors are expected. (Fallback to default language for customer if not provided.) The request language does not affect the name of the copied page: that name uses the content language of the target customer.
     * @param {string} [x_dp_ignore_app_error_codes] Comma separated list of error codes the caller confirmed and that should therefore be disregarded when executing the request. The codes this operation accepts as confirmable are 10215 (FAULT_CBCP_COPY_SOURCE_HAS_CUSTOM_DESIGN) and 10216 (FAULT_CBCP_COPY_TARGET_HAS_CUSTOM_DESIGN), for a Digital Pharma user only, and 10214 (FAULT_CBCP_TARGET_NAMED_PAGE_ALREADY_EXISTS), see the 400 response; any other code named here, and 10215 or 10216 for a user who is not a Digital Pharma user, has no effect and its refusal still applies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public copyNamedPage(x_dp_customer_code: string, page_type_code: string, to_customer_code: string, x_dp_language?: string|null, x_dp_ignore_app_error_codes?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).copyNamedPage(this.axios, x_dp_customer_code, page_type_code, to_customer_code, x_dp_language, x_dp_ignore_app_error_codes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.02 Create content page.
     * @param {ContentPageCreateRestDto} body 
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public createContentPage(body: ContentPageCreateRestDto, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).createContentPage(this.axios, body, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.15 Create home page
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public createHomePage(x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).createHomePage(this.axios, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.20 Create named page
     * @param {string} page_type_code The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public createNamedPage(page_type_code: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).createNamedPage(this.axios, page_type_code, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.05 Delete content page.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public deleteContentPage(page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).deleteContentPage(this.axios, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.01 Get all content pages for a customer.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [search_name] Zoek de resultaten waarbij de opgegeven parameter voorkomt in de waarde van het name veld. (Er wordt case insensitive gezocht.)
     * @param {string} [filter_type_code] Filter de resultaten tot die overeenkomen met het gespecifieerde type
     * @param {string} [filter_library_code] Filter de resultaten tot die waarbij ze behoren tot de gespecifieerde library
     * @param {boolean} [expect_alt_lang_pages] If provided and true, the pages of alternative languages are included in the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public findContentPages(x_dp_customer_code?: string|null, search_name?: string|null, filter_type_code?: string|null, filter_library_code?: string|null, expect_alt_lang_pages?: boolean|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).findContentPages(this.axios, x_dp_customer_code, search_name, filter_type_code, filter_library_code, expect_alt_lang_pages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.04 Get content page.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public getContentPage(page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).getContentPage(this.axios, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.13 Get content page for wysiwyg modus.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public getContentPageWysiwyg(page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).getContentPageWysiwyg(this.axios, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.14 Get home page for wysiwyg modus.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public getHomePageWysiwyg(x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).getHomePageWysiwyg(this.axios, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.19 Get named page for wysiwyg modus.
     * @param {string} page_type_code The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public getNamedPageWysiwyg(page_type_code: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).getNamedPageWysiwyg(this.axios, page_type_code, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.10 Move content page one position down.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public moveContentPageDown(page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).moveContentPageDown(this.axios, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.11 Move content page to position between two others.
     * @param {ElementTargetPositionRestDto} body 
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public moveContentPageTo(body: ElementTargetPositionRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).moveContentPageTo(this.axios, body, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.08 Move content page to the bottom position.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public moveContentPageToBottom(page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).moveContentPageToBottom(this.axios, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.07 Move content page to the top position.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public moveContentPageToTop(page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).moveContentPageToTop(this.axios, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.09 Move content page one position up.
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public moveContentPageUp(page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).moveContentPageUp(this.axios, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.16 Paste a row to this content page.
     * @param {IdRestDto} body 
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public pasteRowOnContentPage(body: IdRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).pasteRowOnContentPage(this.axios, body, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.03 Update content page.
     * @param {ContentPageRestDto} body 
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public updateContentPage(body: ContentPageRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).updateContentPage(this.axios, body, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.12 Update the type of the content page.
     * @param {PageTypeRestDto} body 
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public updateContentPageType(body: PageTypeRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).updateContentPageType(this.axios, body, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.17 Update the field is_published_on_home of the content page.
     * @param {BooleanValueRestDto} body 
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public updateIsPublishedOnHome(body: BooleanValueRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).updateIsPublishedOnHome(this.axios, body, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.CP.18 Update the field status_code of the content page.
     * @param {StatusValueRestDto} body 
     * @param {string} page_id The unique identifier of this content page.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPageEndpointsApi
     */
     public updatePageStatusCode(body: StatusValueRestDto, page_id: string, x_dp_customer_code?: string|null, options?: any) {
        return ContentPageEndpointsApiFp(this.configuration).updatePageStatusCode(this.axios, body, page_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
